import { apiFetch } from '../../actions/apiActions';
import { toast } from 'react-toastify';
import { replaceFileAfterUpload } from '../../OrdersPage/actions/filesActions';
import { getFilesFromNextcloud } from '../../FilesWidget/actions/filesActions';

export function startFileUploadToNextcloud(files) {
  return async (dispatch, getState) => {
    try {
      console.log('files')
      console.log(files)
      if (!files || !files[0]) return;

      const data = new FormData();
      data.append("file", files[0]);
      const totalSize = files[0].size;

      const tempId = Math.random().toString(36);

      let resp = await dispatch(
        apiFetch("/api/data/upload", {
          method: "POST",
          fileUpload: true,
          body: data
        })
      );
      const jsonData = await resp.json();
      if (!resp.ok) {
        throw new Error(jsonData.message);
      } else {
        //reload data in widget sidebar
        dispatch(getFilesFromNextcloud());
      }
      dispatch(
        replaceFileAfterUpload(tempId, {
          uploading: false,
          error: null,
          ...jsonData
        })
      );
    } catch (e) {
      toast(e.message, { type: "error" });
      // dispatch(fileDeleted(tempId));
    }
  };
}
